export default function (source, keys) {
  return Array.from(keys, function (key) {
    return source[key];
  });
}